import { useEffect, useRef } from "react";
import { Play } from "lucide-react";

export default function BookVideoPreview() {
  const sectionRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const video = videoRef.current;

    if (!section || !video) return undefined;

    const playVideo = () => {
      video.play().catch(() => {
        // Browser autoplay policies can still block playback until user interaction.
      });
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          playVideo();
        } else {
          video.pause();
        }
      },
      { threshold: 0.45 }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  const playOnClick = () => {
    videoRef.current?.play().catch(() => {});
  };

  return (
    <section
      id="book-video-preview"
      ref={sectionRef}
      onClick={playOnClick}
      className="bg-[#FBF7EF] px-4 py-16 text-retro-ink sm:px-5 md:px-10 md:py-20"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-9 lg:grid-cols-[0.82fr_1.18fr]">
        <div>
          <p className="font-body text-sm font-bold uppercase tracking-[0.28em] text-[#8B5B2B]">Book Video Preview</p>
          <h2 className="mt-3 font-heading text-3xl uppercase leading-[1.04] text-[#073C2F] sm:text-4xl md:text-6xl">
            See the Book Before You Order
          </h2>
          <p className="mt-5 max-w-lg font-body text-base leading-7 text-[#073C2F]/76 md:text-lg md:leading-8">
            Watch a quick walkthrough of the Note Console pages, layout, and planner feel.
          </p>
          <button
            type="button"
            onClick={playOnClick}
            className="retro-btn mt-7 inline-flex items-center gap-2 bg-retro-yellow px-5 py-3 font-body text-sm font-black uppercase text-retro-ink"
          >
            <Play size={18} fill="currentColor" />
            Play Preview
          </button>
        </div>

        <div className="rounded-lg border-[3px] border-retro-ink bg-white p-2 shadow-[10px_10px_0_rgba(7,60,47,0.18)] sm:p-3">
          <video
            ref={videoRef}
            className="aspect-video w-full rounded-md bg-black object-cover"
            src="/book-video-preview.mp4"
            muted
            loop
            playsInline
            controls
            preload="metadata"
          />
        </div>
      </div>
    </section>
  );
}
